import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Active pages
import Homepage from "../HomePage";
import ScrollToTop from "./ScrollToTop";
import ErrorPage from "../ErrorPage/ErrorPage";
import PresalePage from "../PresalePage/PresalePage";
import AtomTestnetPage from "../AtomTestnetPage/AtomTestnetPage";
import AtomFeaturesPage from "../AtomFeaturesPage/AtomFeaturesPage";

// ✅ Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* ✅ Main Ai Agency home */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />

          {/* ✅ Testnet dashboard sandbox */}
          <Route path="/testnet" element={<AtomTestnetPage />} />

          {/* ✅ Atom features sandbox */}
          <Route path="/features" element={<AtomFeaturesPage />} />

          {/* ✅ Presale landing */}
          <Route path="/presale" element={<PresalePage />} />

          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
